var config = {};
config.endPoint = "https://api2.multipay.ph/api";
config.GraphURL = "GRAPHQL ENDPOINT";
config.baseUrl = "HOST";
config.baseName = "/";
module.exports = config;


/*****************
 ** WEBPACK FOOTER
 ** ./config/app.js
 ** module id = 45
 ** module chunks = 0
 **/